import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-444ad770"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseTableHeader = _resolveComponent("BaseTableHeader")!
  const _component_BaseTableColumnHeaders = _resolveComponent("BaseTableColumnHeaders")!
  const _component_BaseTableRow = _resolveComponent("BaseTableRow")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ((_ctx.rows[0] && _ctx.rows[0].data._breadcrumbHeader) || _ctx.checkHeader ? _ctx.rowsHasThisHeader : true)
      ? (_openBlock(), _createElementBlock("thead", _hoisted_1, [
          _createVNode(_component_BaseTableHeader, {
            "group-heading": _ctx.groupHeading,
            "is-collapsed": _ctx.isCollapsed,
            "onUpdate:isCollapsed": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isCollapsed) = $event)),
            "rows-length": _ctx.rowsLength,
            "column-length": _ctx.columnLength
          }, _createSlots({ _: 2 }, [
            _renderList(Object.keys(_ctx.$slots), (slot, slotIndex) => {
              return {
                name: slot,
                fn: _withCtx((props) => [
                  _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(props)), undefined, true)
                ])
              }
            })
          ]), 1032, ["group-heading", "is-collapsed", "rows-length", "column-length"]),
          _createVNode(_component_BaseTableColumnHeaders, {
            "group-heading": _ctx.groupHeading,
            "rows-length": _ctx.rowsLength,
            "column-length": _ctx.columnLength,
            "sorted-column": _ctx.sortedColumn,
            "sorted-value": _ctx.sortedValue,
            columns: _ctx.columns,
            checkbox: _ctx.checkbox,
            "is-collapsed": _ctx.isCollapsed,
            "onUpdate:isCollapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isCollapsed) = $event)),
            "all-checked": _ctx.allChecked,
            onSetSort: _ctx.setSort,
            onToggleSort: _ctx.toggleSort,
            onToggleAllCheckboxes: _ctx.toggleAllCheckboxes
          }, _createSlots({ _: 2 }, [
            _renderList(Object.keys(_ctx.$slots), (slot, slotIndex) => {
              return {
                name: slot,
                fn: _withCtx((props) => [
                  _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(props)), undefined, true)
                ])
              }
            })
          ]), 1032, ["group-heading", "rows-length", "column-length", "sorted-column", "sorted-value", "columns", "checkbox", "is-collapsed", "all-checked", "onSetSort", "onToggleSort", "onToggleAllCheckboxes"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isCollapsed)
      ? (_openBlock(), _createElementBlock("tbody", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
            return (_openBlock(), _createBlock(_component_BaseTableRow, {
              key: JSON.stringify(row.data),
              index: _ctx.useListIndex ? row.index : row.data._index,
              row: row.data,
              columns: _ctx.columns,
              filter: _ctx.filter,
              route: _ctx.route,
              checkbox: _ctx.checkbox,
              "checked-value": _ctx.checkedItems[_ctx.useListIndex ? row.index : row.data._index],
              "onUpdate:checkedValue": ($event: any) => ((_ctx.checkedItems[_ctx.useListIndex ? row.index : row.data._index]) = $event),
              "cell-options": _ctx.cellOptions,
              "show-checkbox": _ctx.showCheckbox(row)
            }, _createSlots({ _: 2 }, [
              _renderList(Object.keys(_ctx.$slots), (slot, slotIndex) => {
                return {
                  name: slot,
                  fn: _withCtx((props) => [
                    _renderSlot(_ctx.$slots, slot, _normalizeProps(_guardReactiveProps(props)), undefined, true)
                  ])
                }
              })
            ]), 1032, ["index", "row", "columns", "filter", "route", "checkbox", "checked-value", "onUpdate:checkedValue", "cell-options", "show-checkbox"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}